module.exports = __webpack_public_path__ + "media/25.6f4e1a2a.mp4";